import { defineComponent } from "vue";
import InlineSvg from "vue-inline-svg";
export default defineComponent({
    components: {
        InlineSvg
    },
    props: {
        src: {
            type: String,
            required: true
        },
        react: {
            type: Boolean,
            default: true
        }
    },
    data: function () {
        return {
            color: "white",
        };
    },
    methods: {
        onMouseHoverIn: function () {
            if (!this.react)
                return;
            this.$data.color = "orange";
        },
        onMouseHoverOut: function () {
            if (!this.react)
                return;
            this.$data.color = "white";
        }
    }
});
